// AUTO-GENERATED by generateRelayRegistry.ts. Do not edit by hand!
import { type PreloadedQuery } from 'react-relay'
import { type ConcreteRequest } from 'relay-runtime'

import AccountInactiveScreenQueryNode, {
  type AccountInactiveScreenQuery
} from '@/__generated__/AccountInactiveScreenQuery.graphql'
import AccountScreenQueryNode, { type AccountScreenQuery } from '@/__generated__/AccountScreenQuery.graphql'
import AppealPhotosScreenQueryNode, {
  type AppealPhotosScreenQuery
} from '@/__generated__/AppealPhotosScreenQuery.graphql'
import BannedScreenQueryNode, { type BannedScreenQuery } from '@/__generated__/BannedScreenQuery.graphql'
import LikeProfileScreenQueryNode, { type LikeProfileScreenQuery } from '@/__generated__/LikeProfileScreenQuery.graphql'
import LikesListFreeQueryNode, { type LikesListFreeQuery } from '@/__generated__/LikesListFreeQuery.graphql'
import LikesListQueryNode, { type LikesListQuery } from '@/__generated__/LikesListQuery.graphql'
import LikesScreenQueryNode, { type LikesScreenQuery } from '@/__generated__/LikesScreenQuery.graphql'
import MatchMessagesScreenQueryNode, {
  type MatchMessagesScreenQuery
} from '@/__generated__/MatchMessagesScreenQuery.graphql'
import MatchMessagesViewRefetchableQueryNode, {
  type MatchMessagesViewRefetchableQuery
} from '@/__generated__/MatchMessagesViewRefetchableQuery.graphql'
import MatchProfileScreenQueryNode, {
  type MatchProfileScreenQuery
} from '@/__generated__/MatchProfileScreenQuery.graphql'
import MessagesScreenQueryNode, { type MessagesScreenQuery } from '@/__generated__/MessagesScreenQuery.graphql'
import MessagesViewQueryNode, { type MessagesViewQuery } from '@/__generated__/MessagesViewQuery.graphql'
import OnboardingAboutScreenQueryNode, {
  type OnboardingAboutScreenQuery
} from '@/__generated__/OnboardingAboutScreenQuery.graphql'
import OnboardingActivitiesScreenQueryNode, {
  type OnboardingActivitiesScreenQuery
} from '@/__generated__/OnboardingActivitiesScreenQuery.graphql'
import OnboardingBasicsScreenQueryNode, {
  type OnboardingBasicsScreenQuery
} from '@/__generated__/OnboardingBasicsScreenQuery.graphql'
import OnboardingCriteriaScreenQueryNode, {
  type OnboardingCriteriaScreenQuery
} from '@/__generated__/OnboardingCriteriaScreenQuery.graphql'
import OnboardingDeetsScreenQueryNode, {
  type OnboardingDeetsScreenQuery
} from '@/__generated__/OnboardingDeetsScreenQuery.graphql'
import OnboardingLookingForScreenQueryNode, {
  type OnboardingLookingForScreenQuery
} from '@/__generated__/OnboardingLookingForScreenQuery.graphql'
import OnboardingPhotosScreenQueryNode, {
  type OnboardingPhotosScreenQuery
} from '@/__generated__/OnboardingPhotosScreenQuery.graphql'
import OnboardingPromptsScreenQueryNode, {
  type OnboardingPromptsScreenQuery
} from '@/__generated__/OnboardingPromptsScreenQuery.graphql'
import OnboardingTermsScreenQueryNode, {
  type OnboardingTermsScreenQuery
} from '@/__generated__/OnboardingTermsScreenQuery.graphql'
import OwnProfileScreenQueryNode, { type OwnProfileScreenQuery } from '@/__generated__/OwnProfileScreenQuery.graphql'
import PhotoScreenQueryNode, { type PhotoScreenQuery } from '@/__generated__/PhotoScreenQuery.graphql'
import ProfileEditScreenQueryNode, { type ProfileEditScreenQuery } from '@/__generated__/ProfileEditScreenQuery.graphql'
import ProfilePhotosScreenQueryNode, {
  type ProfilePhotosScreenQuery
} from '@/__generated__/ProfilePhotosScreenQuery.graphql'
import ProfilePromptsScreenQueryNode, {
  type ProfilePromptsScreenQuery
} from '@/__generated__/ProfilePromptsScreenQuery.graphql'
import RestrictedStatusGuardQueryNode, {
  type RestrictedStatusGuardQuery
} from '@/__generated__/RestrictedStatusGuardQuery.graphql'
import SearchFiltersScreenQueryNode, {
  type SearchFiltersScreenQuery
} from '@/__generated__/SearchFiltersScreenQuery.graphql'
import SearchProfileScreenQueryNode, {
  type SearchProfileScreenQuery
} from '@/__generated__/SearchProfileScreenQuery.graphql'
import SearchScreenQueryNode, { type SearchScreenQuery } from '@/__generated__/SearchScreenQuery.graphql'
import SearchViewRefetchQueryNode, { type SearchViewRefetchQuery } from '@/__generated__/SearchViewRefetchQuery.graphql'
import SparkBalancePillQueryNode, { type SparkBalancePillQuery } from '@/__generated__/SparkBalancePillQuery.graphql'
import SystemMessagesScreenQueryNode, {
  type SystemMessagesScreenQuery
} from '@/__generated__/SystemMessagesScreenQuery.graphql'
import SystemMessagesViewQueryNode, {
  type SystemMessagesViewQuery
} from '@/__generated__/SystemMessagesViewQuery.graphql'
import UseAppealPhotosQueryNode, { type UseAppealPhotosQuery } from '@/__generated__/UseAppealPhotosQuery.graphql'
import useBadgeSyncQueryNode, { type useBadgeSyncQuery } from '@/__generated__/useBadgeSyncQuery.graphql'
import UseProfilePhotosQueryNode, { type UseProfilePhotosQuery } from '@/__generated__/UseProfilePhotosQuery.graphql'
import UserNavigatorQueryNode, { type UserNavigatorQuery } from '@/__generated__/UserNavigatorQuery.graphql'
import UserRedirectScreenQueryNode, {
  type UserRedirectScreenQuery
} from '@/__generated__/UserRedirectScreenQuery.graphql'
import UseVerificationPhotosQueryNode, {
  type UseVerificationPhotosQuery
} from '@/__generated__/UseVerificationPhotosQuery.graphql'
import VerificationPhotosScreenQueryNode, {
  type VerificationPhotosScreenQuery
} from '@/__generated__/VerificationPhotosScreenQuery.graphql'

export type RelayQueryMap = {
  AccountInactiveScreenQuery: AccountInactiveScreenQuery
  AccountScreenQuery: AccountScreenQuery
  AppealPhotosScreenQuery: AppealPhotosScreenQuery
  BannedScreenQuery: BannedScreenQuery
  LikeProfileScreenQuery: LikeProfileScreenQuery
  LikesListFreeQuery: LikesListFreeQuery
  LikesListQuery: LikesListQuery
  LikesScreenQuery: LikesScreenQuery
  MatchMessagesScreenQuery: MatchMessagesScreenQuery
  MatchMessagesViewRefetchableQuery: MatchMessagesViewRefetchableQuery
  MatchProfileScreenQuery: MatchProfileScreenQuery
  MessagesScreenQuery: MessagesScreenQuery
  MessagesViewQuery: MessagesViewQuery
  OnboardingAboutScreenQuery: OnboardingAboutScreenQuery
  OnboardingActivitiesScreenQuery: OnboardingActivitiesScreenQuery
  OnboardingBasicsScreenQuery: OnboardingBasicsScreenQuery
  OnboardingCriteriaScreenQuery: OnboardingCriteriaScreenQuery
  OnboardingDeetsScreenQuery: OnboardingDeetsScreenQuery
  OnboardingLookingForScreenQuery: OnboardingLookingForScreenQuery
  OnboardingPhotosScreenQuery: OnboardingPhotosScreenQuery
  OnboardingPromptsScreenQuery: OnboardingPromptsScreenQuery
  OnboardingTermsScreenQuery: OnboardingTermsScreenQuery
  OwnProfileScreenQuery: OwnProfileScreenQuery
  PhotoScreenQuery: PhotoScreenQuery
  ProfileEditScreenQuery: ProfileEditScreenQuery
  ProfilePhotosScreenQuery: ProfilePhotosScreenQuery
  ProfilePromptsScreenQuery: ProfilePromptsScreenQuery
  RestrictedStatusGuardQuery: RestrictedStatusGuardQuery
  SearchFiltersScreenQuery: SearchFiltersScreenQuery
  SearchProfileScreenQuery: SearchProfileScreenQuery
  SearchScreenQuery: SearchScreenQuery
  SearchViewRefetchQuery: SearchViewRefetchQuery
  SparkBalancePillQuery: SparkBalancePillQuery
  SystemMessagesScreenQuery: SystemMessagesScreenQuery
  SystemMessagesViewQuery: SystemMessagesViewQuery
  UseAppealPhotosQuery: UseAppealPhotosQuery
  UseProfilePhotosQuery: UseProfilePhotosQuery
  UseVerificationPhotosQuery: UseVerificationPhotosQuery
  UserNavigatorQuery: UserNavigatorQuery
  UserRedirectScreenQuery: UserRedirectScreenQuery
  VerificationPhotosScreenQuery: VerificationPhotosScreenQuery
  useBadgeSyncQuery: useBadgeSyncQuery
}

export type RelayQueryName = keyof RelayQueryMap

export type RelayQueryVariablesByName<N extends RelayQueryName> = RelayQueryMap[N]['variables']
export type RelayQueryResponseByName<N extends RelayQueryName> = RelayQueryMap[N]['response']
export type RelayPreloadedQueryByName<N extends RelayQueryName> = PreloadedQuery<RelayQueryMap[N]>

export const relayQueryNodes: Record<RelayQueryName, ConcreteRequest> = {
  AccountInactiveScreenQuery: AccountInactiveScreenQueryNode,
  AccountScreenQuery: AccountScreenQueryNode,
  AppealPhotosScreenQuery: AppealPhotosScreenQueryNode,
  BannedScreenQuery: BannedScreenQueryNode,
  LikeProfileScreenQuery: LikeProfileScreenQueryNode,
  LikesListFreeQuery: LikesListFreeQueryNode,
  LikesListQuery: LikesListQueryNode,
  LikesScreenQuery: LikesScreenQueryNode,
  MatchMessagesScreenQuery: MatchMessagesScreenQueryNode,
  MatchMessagesViewRefetchableQuery: MatchMessagesViewRefetchableQueryNode,
  MatchProfileScreenQuery: MatchProfileScreenQueryNode,
  MessagesScreenQuery: MessagesScreenQueryNode,
  MessagesViewQuery: MessagesViewQueryNode,
  OnboardingAboutScreenQuery: OnboardingAboutScreenQueryNode,
  OnboardingActivitiesScreenQuery: OnboardingActivitiesScreenQueryNode,
  OnboardingBasicsScreenQuery: OnboardingBasicsScreenQueryNode,
  OnboardingCriteriaScreenQuery: OnboardingCriteriaScreenQueryNode,
  OnboardingDeetsScreenQuery: OnboardingDeetsScreenQueryNode,
  OnboardingLookingForScreenQuery: OnboardingLookingForScreenQueryNode,
  OnboardingPhotosScreenQuery: OnboardingPhotosScreenQueryNode,
  OnboardingPromptsScreenQuery: OnboardingPromptsScreenQueryNode,
  OnboardingTermsScreenQuery: OnboardingTermsScreenQueryNode,
  OwnProfileScreenQuery: OwnProfileScreenQueryNode,
  PhotoScreenQuery: PhotoScreenQueryNode,
  ProfileEditScreenQuery: ProfileEditScreenQueryNode,
  ProfilePhotosScreenQuery: ProfilePhotosScreenQueryNode,
  ProfilePromptsScreenQuery: ProfilePromptsScreenQueryNode,
  RestrictedStatusGuardQuery: RestrictedStatusGuardQueryNode,
  SearchFiltersScreenQuery: SearchFiltersScreenQueryNode,
  SearchProfileScreenQuery: SearchProfileScreenQueryNode,
  SearchScreenQuery: SearchScreenQueryNode,
  SearchViewRefetchQuery: SearchViewRefetchQueryNode,
  SparkBalancePillQuery: SparkBalancePillQueryNode,
  SystemMessagesScreenQuery: SystemMessagesScreenQueryNode,
  SystemMessagesViewQuery: SystemMessagesViewQueryNode,
  UseAppealPhotosQuery: UseAppealPhotosQueryNode,
  UseProfilePhotosQuery: UseProfilePhotosQueryNode,
  UseVerificationPhotosQuery: UseVerificationPhotosQueryNode,
  UserNavigatorQuery: UserNavigatorQueryNode,
  UserRedirectScreenQuery: UserRedirectScreenQueryNode,
  VerificationPhotosScreenQuery: VerificationPhotosScreenQueryNode,
  useBadgeSyncQuery: useBadgeSyncQueryNode
} as const
